import { disableBodyScroll, enableBodyScroll} from "body-scroll-lock";
import React, {useEffect} from "react";
import PropTypes from "prop-types";

export const BodyScrollLockWithGap = ({customTargetElement}) => {
  const scrollOptions = {
    reserveScrollBarGap: true,
    allowTouchMove: el => {
      while (el && el !== document.body) {
        if (el.classList.contains('body-scroll-lock-ignore')) {
          return true;
        }

        el = el.parentElement;
      }
    }
  },
  targetElement = customTargetElement || document.getElementById('site-header');

  useEffect(() => {
    // body-scroll-lock sets body { position: fixed } on iOS Safari to prevent
    // background scrolling. Without an explicit width, the fixed body shrinks
    // to its content width (the full Embla slider row), stretching all sections.
    const prevBodyWidth = document.body.style.width;
    disableBodyScroll(targetElement, scrollOptions);
    document.body.style.width = '100%';
    return () => {
      enableBodyScroll(targetElement, scrollOptions);
      document.body.style.width = prevBodyWidth;
    }
  }, [])

  return null;
};

BodyScrollLockWithGap.propTypes = {
  customTargetElement: PropTypes.object,
};

export default BodyScrollLockWithGap;
